let params;
let allTags;

const sideMenu = document.getElementById("modal-menu-desktop");
const Overlay = document.getElementById("overlay");
const productOverlay = document.getElementById("productOverlay");
const body = document.body;
const ButtonContainer = document.getElementById("button-container");
const requestInfoBtn = document.getElementById("RequestInformation");
const currentURL = window.location.href;
const currentSearchParams = window.location.search;

function isVisible(el) {
	return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

// Document Ready
// Set Body Class to Locale
let localization = getCookie("localization");

if (!localization) {
	localization = "AT";
}
if (localization) {
	body.dataset.locale = localization;
}

document.querySelectorAll(".group > h3").forEach(function (header) {
	header.querySelectorAll("br").forEach(function (br) {
		br.remove();
	});

	if (isVisible(header.nextElementSibling)) {
		header.querySelector("svg").style.transform = "rotate(180deg)";
		header.classList.remove("bg-gray-200");
		header.classList.add("bg-gray-500");
	}
});

// Only one detail open at a time
document.querySelectorAll('details').forEach((D, _, A) => {
	D.ontoggle = _ => { if (D.open) A.forEach(d => { if (d != D) d.open = false }) }
})

if (
	currentSearchParams.indexOf("gclid") > -1 ||
	currentSearchParams.indexOf("utm") > -1
) {
	sessionStorage.setItem("trackParams", currentSearchParams);
}

// Select variant if param set
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('variant')) {
	refreshSelectedVariant(urlParams.get('variant'), false, window.location.pathname + '?variant=' + urlParams.get('variant'));
	scrollToActiveProduct()
} else {
	//refreshSelectedVariant(null, false);
	//scrollToActiveProduct()
}

// The debounce function receives our function as a parameter
const debounceAnimation = (fn) => {
	// This holds the requestAnimationFrame reference, so we can cancel it if we wish
	let frame;
	// The debounce function returns a new function that can receive a variable number of arguments
	return (...params) => {
		// If the frame variable has been defined, clear it now, and queue for next frame
		if (frame) {
			cancelAnimationFrame(frame);
		}
		// Queue our function call for the next frame
		frame = requestAnimationFrame(() => {
			// Call our function and pass any params we received
			fn(...params);
		});
	}
};

const storeScroll = () => {
	if (window.scrollY > 20)
		document.documentElement.dataset.scroll = window.scrollY;
	else
		document.documentElement.removeAttribute("data-scroll");
}

// Listen for new scroll events, here we debounce our `storeScroll` function
document.addEventListener('scroll', debounceAnimation(storeScroll), { passive: true });

// Update scroll position for first time
storeScroll();

// If readmore is clicked, show content
document.querySelectorAll(".readMore").forEach(function (button) {
	button.addEventListener("click", function () {
		button.style.display = "none";
		button.nextElementSibling.style.display = "block";
	});
});

document.querySelectorAll(".product-form__variants").forEach(function (element) {
	element.addEventListener("change", function () {
		let queryParams = new URLSearchParams(window.location.search);
		queryParams.set("variant", this.value);
		window.location.search = queryParams.toString();
	});
});

// region Variant Selection

// !Header Slider next and prev
// Header Slider Productpages - next
document.querySelectorAll(".nextSeries").forEach(function (button, index) {
	button.addEventListener("click", function (e) {
		const seriesHeaderImage = button.closest(".seriesHeaderImage");
		if (isVisible(seriesHeaderImage)) {
			const headerImageScroll = document.querySelector("[headerImageScroll]");
			headerImageScroll.scrollLeft = seriesHeaderImage.offsetWidth * ++index;
		}
	});
});

// Header Slider Productpages - prev
document.querySelectorAll(".prevSeries").forEach(function (button, index) {
	button.addEventListener("click", function (e) {
		const seriesHeaderImage = button.closest(".seriesHeaderImage");
		if (isVisible(seriesHeaderImage)) {
			const headerImageScroll = document.querySelector("[headerImageScroll]");
			headerImageScroll.scrollLeft = seriesHeaderImage.offsetWidth * --index;
		}
	});
});

// Close and open and add noscroll, background to body & change SVGs
body.addEventListener('click', function () {
	if (this.classList.contains('modelSelectHeader')) {
		const modelSelectBackdrop = document.querySelector('.modelSelectBackdrop');
		const svgX = document.querySelector('.svgX');
		const svgToggle = document.querySelector('.svgToggle');
		if (isVisible(modelSelectBackdrop)) {
			svgX.style.display = 'none';
			svgToggle.style.display = "block";
			modelSelectBackdrop.style.display = 'none';
			document.body.classList.remove('noscroll');
		} else {
			svgToggle.style.display = 'none';
			svgX.style.display = "block";
			document.body.classList.add('noscroll');
			modelSelectBackdrop.style.display = "block";
		}
	}
});

function refreshSelectedVariant(dataId, scroll = true, url) {
	const id = dataId ?? getDataFromTopModel('id');
	const url_ = url ?? getDataFromTopModel('url');

	if (!id) return;

	history.replaceState('', '', url_);

	// Show active containers and hide others
	const productDisplayContainers = document.querySelectorAll(
		".productDisplayContainer"
	);

	if (!productDisplayContainers.length) return;

	for (const container of productDisplayContainers) {
		if (id != container.dataset.id) container.classList.add("hidden");
		else {
			container.classList.remove("hidden");
			document.dispatchEvent(new CustomEvent("slider:sections-reloaded", { detail: { sectionId: container.getAttribute('data-section') } }));
		}
	}

	// Highlight selected variant
	const allVariantSelects = document.querySelectorAll("[topModel]");
	for (const variantSelect of allVariantSelects) {
		const variantSelectImg = variantSelect.querySelector("img");

		if (id != variantSelect.dataset.id) {
			variantSelectImg.classList.remove("border-beta-green-500", "border-t-[3px]", "shadow-lg");
			variantSelectImg.classList.add("border-gray-200", "border");
		} else {
			variantSelectImg.classList.remove("border-gray-200", "border");
			variantSelectImg.classList.add("border-beta-green-500", "border-t-[3px]", "shadow-lg");
		}
	}

	if (scroll) {
		window.scrollTo({
			top: document.querySelector("#product-details").offsetTop - 90,
			behavior: "smooth"
		});
	}

	scrollToActiveProduct(true);
	getSelectData(url);
}

function getSelectedVariant(url, id, prodUrl) {
	if (url == window.location.pathname) {
		document.querySelector('[data-innercontainer]').classList.add('scale-y-0');
		document.body.classList.remove('noscroll');
		refreshSelectedVariant(id, true, url + '?variant=' + id);
		scrollToActiveProduct();
		getSelectData(prodUrl);
	} else {
		document.body.classList.remove('noscroll');
		document.querySelector('[data-innercontainer]').classList.add('scale-y-0');
		scrollToActiveProduct();
	}
}

// function for handling variant data
function getSelectData(url_) {
	// init data object, so only 1 var to pass
	const data = {
		url: url_,
		options: []
	}

	const variantId = getIdFromUrl(window.location.search)

	if (url_ == undefined) {
		data.container = document.querySelector(".productDisplayContainer:not(.hidden)");
	} else if (variantId) {
		data.container = document.querySelector(`[data-product="${variantId}"]`);
	} else {
		data.container = document.querySelector(`[data-url="${data.url}"]`);
	}
	data.selectors = data.container.querySelectorAll(".variantSelect");
	if (data.selectors.length == 0) return;
	data.options = [...data.selectors].map((selector) => selector.value);
	changeCurrentImage(data);
	changeCurrentData(data);
	data.selectors.forEach(function (e, i) {
		e.addEventListener("change", function () {
			data.options[i] = e.value;
			changeCurrentImage(data);
			changeCurrentData(data);
		});
	})
}

function changeCurrentImage(data) {
	const optionsText = data.options.join(";").replaceAll(" ", "");
	const swiper = data.container.querySelector("swiper-container").swiper;
	swiper.update();
	const slideIndex = swiper.slides.findIndex(slide => slide.querySelector('[data-options]').dataset.options === optionsText);
	swiper.slideTo(slideIndex, 300, false);
}

function getIdFromUrl(url) {
	const urlParams = new URLSearchParams(url)
	const variantId = urlParams.get('variant')
	if (!variantId) {
		return null
	}
	return variantId
}

function changeCurrentData(data) {
	const optionsText = data.options.join(";").replaceAll(" ", "").toLowerCase();
	let metafields;
	if (data.container.getAttribute(optionsText)) {
		metafields = data.container.getAttribute(optionsText).split(";");
		metafields.forEach(el => {
			let field = el.split("§");
			field[0] == "weight" ? field[1] += " kg" : field[1];
			document.querySelectorAll(`[data-${field[0]}]`).forEach(el => {
				el.innerHTML = field[1]
			});
		})
	}

	document.dispatchEvent(new CustomEvent('variantChange', {
		detail: { data, metafields }
	}));
}

function linkToCollection(collectionUrl, productId) {
	location.href = collectionUrl + '?variant=' + productId;
}

let observer = new MutationObserver(function (mutations) {
	if (getComputedStyle(document.querySelector("#banner-wrapper")).display === "flex" && !document.body.classList.contains("noscroll")) {
		document.body.classList.add("noscroll");
	}
});

if (document.querySelector('#banner-wrapper')) {
	observer.observe(document.querySelector('#banner-wrapper'), {
		attributes: true
	});
}

document.querySelectorAll(".banner-main_buttons > .btn-accept").forEach(function (btnAccept) {
	btnAccept.addEventListener("click", function () {
		observer.disconnect();
		body.classList.remove("noscroll");
	});
});

function bounceSlider(swiperContainer, numberOfSlides = 1, duration = 300, startDelay = 100, delayBetween = 200) {
	const observer = new IntersectionObserver(entries => {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				setTimeout(() => {
					this.slideNext(duration, false);
				}, startDelay);
				setTimeout(() => {
					this.slidePrev(duration, false);
				}, startDelay + delayBetween + duration);
				observer.unobserve(swiperContainer);
			}
		}, swiperContainer.swiper);
	});
	observer.observe(swiperContainer);
}

// check which product card is active and scroll both model selectors to active product
function scrollToActiveProduct(onlyDropdown = false) {
	document.querySelectorAll(".product-card-variant").forEach(function (productCard) {
		if (productCard.querySelector("img").classList.contains("border-beta-green-500")) {
			const index = parseInt(productCard.dataset.index ? productCard.dataset.index : productCard.dataset.productcardcontainer) - 1;
			const position = (index * productCard.offsetWidth) + (index * 12);
			if (document.querySelector("[data-modelsinnercontainer]"))
				document.querySelector("[data-modelsinnercontainer]").scrollLeft = position;
			if (!onlyDropdown && document.querySelector("[data-slider='modelSlider']")) {
				document.querySelector("[data-slider='modelSlider']").scrollLeft = position;
			}
		}
	});
}

function markActiveSeriesCat() {
	const seriesArrayElements = document.querySelectorAll("[data-seriesArray]");
	seriesArrayElements.forEach(function (element) {
		element.classList.remove("active-series");
		element.classList.add("inactive-series");

		const urlArray = element.dataset.seriesarray.split(";");
		if (urlArray.includes(window.location.pathname)) {
			element.classList.remove("inactive-series");
			element.classList.add("active-series");

			const index = element.dataset.index;
			const seriesIdElements = document.querySelectorAll("[data-seriesid]");
			seriesIdElements.forEach(function (idElement) {
				if (idElement.dataset.index == index) {
					idElement.style.display = "block";
				} else {
					idElement.style.display = "none";
				}
			});
			return false;
		}
	});
}

document.addEventListener('click', function (e) {
	if (e.target.matches('*[data-stop-propagation], *[data-stop-propagation] *')) {
		e.stopPropagation();
	}

	else if (e.target.matches('*[data-close-modal], *[data-close-modal] *')) {
		e.preventDefault();
		const trigger = e.target?.dataset.closeModal || e.target.closest('*[data-close-modal]')?.dataset.closeModal;
		if (!trigger) return;
		closeModal(trigger);
	}		

	else if (e.target.matches('a[data-open-modal], a[data-open-modal] *')) {
		e.preventDefault();
		const trigger = e.target?.dataset.openModal || e.target.closest('a[data-open-modal]')?.dataset.openModal;
		if (!trigger) return;
		openModal(trigger);
	}

	else if (e.target.matches('a[data-toggle-modal], a[data-toggle-modal] *')) {
		e.preventDefault();
		const trigger = e.target?.dataset.toggleModal || e.target.closest('a[data-toggle-modal]')?.dataset.toggleModal;
		if (!trigger) return;
		toggleModal(trigger);
	}

	else if (e.target.matches('a[data-modal-escapable], a[data-modal-escapable] *')) {
		e.preventDefault();
		const trigger = e.target?.dataset.modalEscapable || e.target.closest('a[data-modal-escapable]')?.dataset.modalEscapable;
		if (!trigger) return;
		registerEscapeClosing(trigger);
	}
});

function registerEscapeClosing(e) {
	document.body.addEventListener("keyup", function (t) {
		if (t.key === "Escape") {
			closeModal(e);
		}
	}, { once: true });
}

function openModal(e) {
	const modal = document.getElementById(e);
	const body = document.body;

	if (e === "modal-menu") {
		modal.style.display = "block";
		body.classList.add(e);
	} else if (e === "modal-cart") {
		modal.style.right = "0";
		body.classList.add("no-scrollbar", e);
		if (document.querySelector('.cart-recommendations:not([data-recommendations-loaded])')) {
			fetch(document.querySelector('.cart-recommendations:not([data-recommendations-loaded])').dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('.shopify-section');
					const cartRecommendations = document.getElementById('cart-recommendations');
					cartRecommendations.innerHTML = recommendations.innerHTML;
					cartRecommendations.dataset.recommendationsLoaded = true;
				})
				.catch((error) => {
					console.error(error);
				})
		}
	} else {
		modal.style.display = "block";
		body.classList.add("no-scrollbar", e);
	}

	document.dispatchEvent(new CustomEvent("modalOpened", { detail: { modal: e } }));
}

function closeModal(e) {
	const modal = document.getElementById(e);
	const body = document.body;
	if (e === "modal-cart") {
		modal.style.right = "-100%";
		body.classList.remove("no-scrollbar", e);
	} else {
		modal.style.display = "none";
		body.classList.remove("no-scrollbar", e);
	}
}

function toggleModal(e) {
	const modal = document.getElementById(e);

	if (getComputedStyle(modal).display === "none") {
		openModal(e);
	} else {
		closeModal(e);
	}
}

function addSubmissionEventToGTM() {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: "formSubmission",
	});
}

function disclaim(e, t) {
	if ("accepted" !== localStorage.getItem("disclaimer")) {
		const a = document.createElement("a");
		a.setAttribute("href", "#"),
			(a.className = "closeDisclaim"),
			(a.text = t);
		let o = document.createElement("span");
		o.innerHTML = e;
		let l = document.createElement("div");
		l.setAttribute("id", "cookie-disclaimer"),
			l.appendChild(a),
			l.appendChild(o),
			document.getElementsByTagName("body")[0].appendChild(l),
			setTimeout(function () {
				document.getElementById("cookie-disclaimer").className =
					"visible";
			}, 700),
			document
				.querySelector("#cookie-disclaimer a.closeDisclaim")
				.addEventListener(
					"click",
					() => (
						document
							.getElementById("cookie-disclaimer")
							.classList.remove("visible"),
						localStorage.setItem("disclaimer", "accepted"),
						!1
					)
				);
	}
}

function getDataFromTopModel(data) {
	const topVariant = document.querySelector(`#${CSS.escape(window.location.pathname)} [topModel="true"]`);
	const firstVariant = document.querySelector(`#${CSS.escape(window.location.pathname)} [topModel]`);

	if (!topVariant && !firstVariant) {
		return null;
	}

	if (topVariant) {
		return data == 'url' ? topVariant.dataset.url : topVariant.dataset.id;
	} else {
		return data == 'url' ? firstVariant.dataset.url : firstVariant.dataset.id
	}
}

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': type == 'html' ? 'text/html' : `application/${type}` }
	};
}

function deepMerge(...sources) {
	let merged = {};
	for (const source of sources) {
		for (const key in source) {
			if (source.hasOwnProperty(key)) {
				if (Array.isArray(source[key]) && Array.isArray(merged[key])) {
					merged[key] = [...source[key], ...merged[key]];
				} else if (source[key] instanceof Object && merged[key] instanceof Object) {
					deepMerge(merged[key], source[key]);
				} else {
					merged[key] = source[key];
				}
			}
		}
	}
	return merged;
}

function decodeHtml(html) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');
	return doc.documentElement.textContent;
}

/* After legacy-blog-form.js is removed (blog form is replaced with hubspot form), jquery can be removed completely */